import logo from "assets/img/logo/logo_aig_login-2.png";
import React from "react";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import Page from "../../components/Page";
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Row,
} from "reactstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from 'primereact/inputtext';
import { urlListarPolizasEmitidasVigentes } from "../../constants/urls";
import LoadingScreen from "react-loading-screen";
import OptionMenu from "../../components/Buttons/OptionMenu";



class TablaPolizasVigentes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            registros: [],
            totalRecords: 0,
            loading: true,
            filtros: {
                cod_agente: ""
            },
            filtrados: {
                cod_agente: ""
            },
            lazyParams: {
                first: 0,
                rows: 20,
                page: 0,
                openPageSelect: false
            },
            dataPolizas: [],
            visiblePopovers: {}
        };
    }

    estado = this;

    componentDidMount() {
        this.fetchData();
    }

    fetchData = () => {
        const { lazyParams, filtros } = this.state;
        const { page, rows } = lazyParams;

        this.setState({ loading: true });

        const body = {
            empCodigo: "AIGMETROPOLITANA",
            page: page + 1,
            pageSize: rows,
            filtros: {
                cod_agente: this.props.datosUsuario.brokerCodigo ? this.props.datosUsuario.brokerCodigo : "",
                ...Object.fromEntries(
                    Object.entries(filtros).filter(([, v]) => v !== "")
                ),
            }
        };

        fetch(urlListarPolizasEmitidasVigentes,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(body),
            }
        )
            .then((res) => res.json())
            .then((json) => {
                if (json.transaction === true) {
                    this.setState({
                        dataPolizas: json.data.data,
                        totalRecords: json.data.total,
                        loading: false,
                    });
                } else {
                    this.setState({ loading: false });
                }
            })
            .catch(() => this.setState({ loading: false }));
    };


    toggleUserCardPopover = (id) => {
        this.setState((prevState) => ({
            visiblePopovers: {
                ...{},
                [id]: !prevState.visiblePopovers[id] !== undefined ? !prevState.visiblePopovers[id] : false
            }
        }));
    };

    // ── Actualiza un filtro individual en el estado ────────────────────────────
    onFilterChange = (field, value) => {
        this.setState((prev) => ({
            filtros: { ...prev.filtros, [field]: value },
        }));
    };

    // ── Genera un input de texto reutilizable para cada columna ───────────────
    renderTextFilter = (field) => {
        return (
            <InputText
                value={this.state.filtros[field] || ""}
                onBlur={() => {
                    if ((
                        this.state.filtros[field] !== "" &&
                        this.state.filtros[field] !== undefined &&
                        this.state.filtrados[field] !== this.state.filtros[field]) ||
                        (this.state.filtros[field] === "" && this.state.filtrados[field] !== "")
                    ) {
                        this.onFilterData()
                        this.setState((prev) => ({
                            filtrados: { ...prev.filtrados, [field]: this.state.filtros[field] },
                        }));
                    }
                }}
                onChange={(e) => this.onFilterChange(field, e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
            />
        );
    };

    clearFilters = () => {
        this.setState(
            {
                filtros: {
                    cod_agente: this.props.datosUsuario.brokerCodigo ? this.props.datosUsuario.brokerCodigo : "",
                },
                filtrados: {
                    cod_agente: this.props.datosUsuario.brokerCodigo ? this.props.datosUsuario.brokerCodigo : "",
                },
                lazyParams: { ...this.state.lazyParams, page: 0 },
            },
            () => {
                this.fetchData();
            }
        );
    }

    toggleDropdown = () => {
        this.setState(prev => ({ lazyParams: { ...prev.lazyParams, openPageSelect: !prev.lazyParams.openPageSelect } }));
    };

    onFilterData = () => {
        this.setState(
            {
                lazyParams: {
                    ...this.state.lazyParams,
                    page: 0
                }
            },
            () => {
                this.fetchData();
            }
        );
    }

    selectOption = (newRows) => {
        this.setState(
            {
                lazyParams: {
                    ...this.state.lazyParams,
                    rows: newRows,
                    page: 0,
                    openPageSelect: false,
                },
                openPageSelect: false,
            },
            () => {
                this.fetchData();
            }
        );
    };

    changePage = (newPage) => {
        if (newPage < 0) return;
        this.setState({ lazyParams: { ...this.state.lazyParams, page: newPage } }, () => {
            this.fetchData();
        });
    };

    renderPaginator() {
        const { lazyParams, totalRecords } = this.state;
        const { page, rows } = lazyParams;

        const totalPages = Math.ceil(totalRecords / rows);
        const maxVisible = 5;

        let start = Math.max(page - Math.floor(maxVisible / 2), 0);
        let end = start + maxVisible;

        if (end > totalPages) {
            end = totalPages;
            start = Math.max(end - maxVisible, 0);
        }

        const pages = [];
        for (let i = start; i < end; i++) {
            pages.push(i);
        }

        return (
            <div className="p-paginator p-component p-unselectable-text p-paginator-bottom">
                {/* FIRST */}
                <button
                    type="button"
                    className={`p-paginator-first p-paginator-element p-link ${page === 0 ? 'p-disabled' : ''}`}
                    onClick={() => this.changePage(0)}
                    disabled={page === 0}
                >
                    <span className="p-paginator-icon pi pi-step-backward"></span>
                </button>

                {/* PREV */}
                <button
                    type="button"
                    className={`p-paginator-prev p-paginator-element p-link ${page === 0 ? 'p-disabled' : ''}`}
                    onClick={() => this.changePage(page - 1)}
                    disabled={page === 0}
                >
                    <span className="p-paginator-icon pi pi-caret-left"></span>
                </button>

                {/* PAGES */}
                <span className="p-paginator-pages h-auto" >
                    {pages.map(p => (
                        <button
                            key={p}
                            type="button"
                            className={`p-paginator-page p-paginator-element p-link ${p === page ? 'p-highlight' : ''}`}
                            onClick={() => this.changePage(p)}
                        >
                            {p + 1}
                        </button>
                    ))}
                </span>

                {/* NEXT */}
                <button
                    type="button"
                    className={`p-paginator-next p-paginator-element p-link ${page >= totalPages - 1 ? 'p-disabled' : ''}`}
                    onClick={() => this.changePage(page + 1)}
                    disabled={page >= totalPages - 1}
                >
                    <span className="p-paginator-icon pi pi-caret-right"></span>
                </button>

                {/* LAST */}
                <button
                    type="button"
                    className={`p-paginator-last p-paginator-element p-link ${page >= totalPages - 1 ? 'p-disabled' : ''}`}
                    onClick={() => this.changePage(totalPages - 1)}
                    disabled={page >= totalPages - 1}
                >
                    <span className="p-paginator-icon pi pi-step-forward"></span>
                </button>


                <div className="p-dropdown p-component p-inputwrapper-filled tpv-dd">
                    <div className="p-dropdown-label p-inputtext tpv-dd-label" onClick={this.toggleDropdown}>
                        {this.state.lazyParams.rows || '10'}
                        <div className="p-dropdown-trigger" role="button" aria-haspopup="listbox" aria-expanded="false"><span className="p-dropdown-trigger-icon pi pi-chevron-down p-clickable"></span></div>
                    </div>
                    {this.state.lazyParams.openPageSelect && (
                        <ul className="tpv-dd-panel">
                            {[20, 30, 50].map(opt => (
                                <li
                                    key={opt}
                                    className={`tpv-dd-item ${(this.state.lazyParams.rows || 10) === opt ? 'active' : ''}`}
                                    onClick={() => this.selectOption(opt)}
                                >
                                    {opt}
                                </li>
                            ))}
                        </ul>
                    )}
                </div>

            </div>
        );
    }

    renderLimpiarFiltrosButton = () => {
        return (

            <Col style={{ textAlign: "end" }}>
                <Button className={"btn btn-primary"} style={{ margin: "auto" }} onClick={this.clearFilters}>
                    <i className="fa fa-trash-o" aria-hidden="true" /> Limpiar filtros
                </Button>
            </Col>

        );
    }

    renderOpciones = (rowData, conf) => {
        const opciones = rowData.opciones ? rowData.opciones : [];
        const idOpcion = `PopOverMenuOptions-${conf.rowIndex}`;

        if (opciones.length !== 0) {
            return (
                <div className="flex flex-row">
                    <OptionMenu
                        dataProps={this.props}
                        idOpcion={idOpcion}
                        isOpen={this.state.visiblePopovers[idOpcion] !== undefined ? this.state.visiblePopovers[idOpcion] : false}
                        opciones={opciones}
                        toggleUserCardPopover={this.toggleUserCardPopover}
                        state={this.state}
                        data={rowData}
                    />
                </div>
            );
        } else {
            return (
                <div className="flex flex-row" style={{ opacity: 0.6, cursor: "not-allowed" }}>
                    <button
                        disabled
                        className="btn-ellipsis"
                    >
                        <i className="fa fa-ellipsis-v"></i>
                    </button>
                </div>
            )
        }
    }

    renderMensajeCantidad = () => {
        const page = this.state.lazyParams.page + 1;
        const rows = this.state.lazyParams.rows;
        const total = this.state.totalRecords;
        const desde = total !== 0 ? ((page - 1) * rows) + 1: 0;
        const hasta = Math.min(page * rows, total);

        return ( 
            <Col>
                {`Mostrando ${desde} - ${hasta} de ${total} pólizas`}
            </Col>
        );
    }

    render() {
        return (
            <main className="bg-light">
                <div className="cr-content container-fluid">
                    <div className="container-body-spaces">
                        <LoadingScreen
                            loading={this.state.loading}
                            bgColor="#f1f1f1"
                            spinnerColor="#001871"
                            textColor="#676767"
                            logoSrc={logo}
                            text={"Obteniendo registros..."}
                        >
                            <Page title={"Listado de pólizas vigentes"}>
                                {/* {this.state.dataPolizas.length > 0 && ( */}
                                <div>
                                    <Row >

                                        {this.renderMensajeCantidad()}
                                        {this.renderLimpiarFiltrosButton()}

                                    </Row>
                                    <Row>
                                        <Col>
                                            <Card body>
                                                <DataTable
                                                    value={this.state.dataPolizas}
                                                    responsive
                                                    className="p-datatable-customers"
                                                    rowHover
                                                    resizableColumns
                                                    emptyMessage={
                                                        <Card className="mb-3">
                                                            <CardHeader style={{ borderBottom: "none" }}></CardHeader>
                                                            <CardBody>
                                                                <h2 style={{ color: "#001871", textAlign: "center" }}>
                                                                    SIN REGISTROS
                                                                </h2>
                                                            </CardBody>
                                                        </Card>
                                                    }
                                                >
                                                    <Column
                                                        header="#"
                                                        body={(data, conf) => {
                                                            const page = this.state.lazyParams.page + 1;
                                                            const pageSize = this.state.lazyParams.rows;
                                                            const total = this.state.totalRecords;
                                                            return (<div>
                                                                {((page - 1) * pageSize) + conf.rowIndex + 1}
                                                            </div>)
                                                        }
                                                        }
                                                        style={{ width: "50px" }}
                                                    />
                                                    <Column
                                                        field="id_pv"
                                                        header="IDPV"
                                                        style={{ width: "100px" }}
                                                        filter
                                                        filterElement={this.renderTextFilter("id_pv")}

                                                    />
                                                    <Column
                                                        header="Nro. PÓLIZA"
                                                        field="nro_pol"
                                                        style={{ width: "100px" }}
                                                        filter
                                                        filterElement={this.renderTextFilter("nro_pol")}

                                                    />
                                                    <Column
                                                        header="RAMO"
                                                        field="ramo"
                                                        style={{ width: "150px" }}
                                                        filter
                                                        filterElement={this.renderTextFilter("ramo")}

                                                    />
                                                    <Column
                                                        header="NRO. ENDOSO"
                                                        field="nro_endoso"
                                                        style={{ width: "100px" }}

                                                    />
                                                    <Column
                                                        header="SUCURSAL"
                                                        field="Sucursal"
                                                        style={{ width: "100px" }}
                                                        filter
                                                        filterElement={this.renderTextFilter("Sucursal")}

                                                    />
                                                    <Column
                                                        header="FECHA INICIO DE VIGENCIA"
                                                        field="fec_ini_vig"
                                                        style={{ width: "150px" }}
                                                        filter
                                                        filterElement={this.renderTextFilter("fec_ini_vig")}

                                                    />
                                                    <Column
                                                        header="FECHA FIN DE VIGENCIA"
                                                        field="fec_fin_vig"
                                                        style={{ width: "150px" }}
                                                        filter
                                                        filterElement={this.renderTextFilter("fec_fin_vig")}

                                                    />
                                                    <Column
                                                        header="CONTRATANTE IDENTIFICACIÓN"
                                                        field="ContratanteIdentificacion"
                                                        style={{ width: "150px" }}
                                                        filter
                                                        filterElement={this.renderTextFilter("ContratanteIdentificacion")}

                                                    />
                                                    <Column
                                                        header="CONTRATANTE NOMBRE / RAZÓN SOCIAL"
                                                        field="ContratanteNombres"
                                                        style={{ width: "150px" }}
                                                        filter
                                                        filterElement={this.renderTextFilter("ContratanteNombres")}

                                                    />
                                                    <Column
                                                        header="FECHA VIGENCIA DEL FORM. DE VINCULACIÓN"
                                                        field="fec_vig_hasta_fv"
                                                        style={{ width: "150px" }}

                                                    />
                                                    <Column
                                                        header="ACCIONES"
                                                        body={(rowData, conf) => this.renderOpciones(rowData, conf)}
                                                        style={{ width: "150px" }}
                                                    />
                                                </DataTable>
                                                <div className="p-datatable">
                                                    {this.renderPaginator()}
                                                </div>
                                            </Card>
                                        </Col>
                                    </Row>
                                </div>
                            </Page>
                        </LoadingScreen>
                    </div>
                </div>
            </main>
        );
    }
}

const mapStateToProps = (state) => ({
    datosUsuario: state.datosUsuarios.dataUsuario,
});

const mapDispatchToProps = (dispatch) => {
    return {};
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(TablaPolizasVigentes)
);